import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { filter, takeUntil, switchMap } from 'rxjs/operators';
import { Subject, Observable, EMPTY } from 'rxjs';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import * as moment from 'moment';
import * as _ from 'underscore';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { sweetAlert } from 'src/app/utils/swal';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { FleetService } from '../../fleet/fleet-service/fleet.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-trip-sheet',
  templateUrl: './trip-sheet.component.html',
  styleUrls: ['./trip-sheet.component.css']
})
export class TripSheetComponent implements OnInit, OnDestroy {
  /** Grid row height (px) for 5-minute slots; keep in sync with template `repeat(288, 7.619px)`. */
  readonly tripSheetRowPx = 7.619;
  @ViewChild("timer1", { static: false }) timer;
  /**
   * Static cushion strip classes; height/top come from {@link getTripCushionStripStyle} (travel-based).
   * li width is already split for overlaps (50/50 etc.).
   */
  readonly tripSheetCushionBaseClass =
    'absolute left-0 right-0 z-[5] box-border bg-gray-200 rounded-t-lg';
  duration = 20 * 1000; // 20 seconds
  driverList = [];
  user;
  isShowAllTrips = false;
  isAllowToHover = false;
  todayDate;
  skip = 0;
  driverTrips = {};
  allTrips = [];
  drivers = [];
  selectedDropdownIndex: any;
  toggleActionButtons: boolean = false;
  timeZone;
  search;
  stationManagerList = [];
  preStaffList = {};
  selectedServiceArea = '';
  filteredServiceAreas = [];
  serviceAreaList = [];
  preServiceAreas = {};
  selectedDriver;
  selectedStationManager;
  filteredDrivers = [];
  tripDetailModalObj;
  completedTripModalObj;
  isUnAssignEnabled = false;
  isCancelUnabled = false;
  showSlideFilter = false;
  showBreak = true;
  preDriverList = {};
  driverShift = true;
  corporateList = [];
  preCooperates = {};
  levelOfServiceList = [];
  preLevelOfServices = {};
  spaceTypeList = [];
  preSpaceTypes = {};
  filteredCorporates = [];
  filteredLevelOfService = [];
  filteredSpaceTypes = [];
  driversPerPage = 10;
  isTimerEnabled = false;
  /** Visible driver column width: adjust by ±5, between min and max. */
  readonly driversPerPageMin = 5;
  readonly driversPerPageMax = 25;
  readonly driversPerPageStep = 5;
  selectedSpaceType = '';
  selectedCooperate = '';
  selectedLOS = '';
  hoveredTrip = null;
  /** Left time rail: 30-min steps (0000, 0030, …, 2330); matches repeat(48, 80px) timeline rows */
  timeAxisHalfHourLabels: { label: string; onHour: boolean }[] = (() => {
    const ticks: { label: string; onHour: boolean }[] = [];
    for (let h = 0; h < 24; h++) {
      const hh = h < 10 ? '0' + h : String(h);
      ticks.push({ label: hh + '00', onHour: true });
      ticks.push({ label: hh + '30', onHour: false });
    }
    return ticks;
  })();
  preAssistList
  status = "active";
  preFleetList;
  sortBy: 'trip' | 'vehicle' = 'trip';
  tripStatuses = [
    { label: 'Assigned', status: 'hanging', isChecked: true },
    { label: 'En Route', status: 'onway', isChecked: false },
    { label: 'Arrived', status: 'arrived', isChecked: false },
    { label: 'In Progress', status: 'started', isChecked: false },
    { label: 'Completed', status: 'finished', isChecked: false },
    { label: 'Cancelled', status: 'cancelled', isChecked: false },
  ];
  isShowStatusDropdown = false;

  selectedDate: any;
  timeRange: any;
  scheduleTime:any;
  driverId;
  isRdispatcher = false;
  driversTimelines = {};
  isShowColorInformation = false;
  showUnassignedSidebar = true;
  selectedTrip;
  undoStack: Array<{
    type: 'assign' | 'reschedule';
    trip: any;
    prevDriverId: any;
    prevStatus: string;
    prevJobStatus: string;
    driverName: string;
    prevScheduleTime?: string;
    prevAppointmentTime?: string | null;
  }> = [];
  version = '2';
  assignModalObj;
  componentType;
  secondaryCompType;
  driverTripModalObj: any;
  timeRescheduleModalObj: {
    trip: any;
    oldScheduleTime: string;
    oldAppointmentTime: string | null;
    newScheduleTime: string;
    newAppointmentTime: string | null;
    oldTimeDisplay: string;
    newTimeDisplay: string;
  } | null = null;

  constructor(
    private cdr: ChangeDetectorRef,
    private fleetService: FleetService,
    private assistService : AssistService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private staffService: StaffService,
    private serviceArea: ServiceAreasService,
    private corporateService : CorporateService,
    private levelOfServiceService : LevelOfServiceService
  ) { }

  private refreshSubject = new Subject<void>();
  currentTimePosition: number = 0;
  private timeInterval: any;


  ngOnInit(): void {
    this.getUser();
    this.setupRefreshListener();
  }

  setupRefreshListener() {
    this.refreshSubject.pipe(
      takeUntil(componentDestroyed(this)),
      switchMap(() => {
        this.allTrips = [];
        this.skip = 0;
        return this.fetchTripsInBatches();
      })
    ).subscribe();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data
          this.timeZone = data.timeZone;
          this.setupTimeIndicator();
          this.todayDate = moment.tz(this.timeZone).startOf("day").toISOString(),
          this.timeRange = [moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(), moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString()];


          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStationManager = [this.user.sId];
            this.isRdispatcher = true;
          }

          this.getDriverList();
        }
      });
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        });
  }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, "active")
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            if (this.isRdispatcher) {
              data = data.filter(item => item.stationManager === this.user.sId);
            }

            this.driverList = data;

            this.getStaffList();
            this.getServiceAreas();
            this.getCorporate();
            this.getLevelOfService();
            this.getFleetList();
            this.getSpaceTypes();
            this.getAssisData();
            this.getTrips();
            this.getDriversTimelines();
          }
        },
      );
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  fetchTripsInBatches(): Observable<any> {
    const jobStatuses = ['pending'];
    this.tripStatuses.forEach(t => {
      if (t.isChecked) {
        if (t.status === 'hanging') {
          jobStatuses.push('offered', 'accepted');
        } else {
          jobStatuses.push(t.status);
        }
      }
    });

    const body = {
      isShowAllTrips: this.isShowAllTrips,
      status: 'manifest',
      date: this.timeRange,
      showBreak: this.showBreak,
      skip: this.skip,
      jobStatuses
    };

    return this.assignTripService.getAssignList(body).pipe(
      switchMap(data => {
        if (data && data.length) {
          this.allTrips = _.uniq([...this.allTrips, ...data], '_id');
          this.skip += data.length;
          this.allTripsFilteration();
          return this.fetchTripsInBatches();
        } else {
            if (this.timer) {
                if (this.isTimerEnabled)
                  this.timer.start();
              }
          this.isAllowToHover = true;
          this.allTripsFilteration();
          return EMPTY;
        }
      })
    );
  }

  getTrips() {
    this.refreshSubject.next();
  }

  refreshTrips() {
    this.getTrips();
  }

  updateCurrentTimePosition() {
    const now = moment().tz(this.timeZone);
    const isToday = now.isSame(moment(this.todayDate).tz(this.timeZone), 'day');
    if (isToday) {
      this.currentTimePosition = this.getStartPoint(now.toISOString(), true);
    } else {
      this.currentTimePosition = 0;
    }
  }

  setupTimeIndicator() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    this.updateCurrentTimePosition();
    this.scrollToCurrentTime();
    this.timeInterval = setInterval(() => {
      this.updateCurrentTimePosition();
    }, 60000);
  }

  scrollToCurrentTime() {
    setTimeout(() => {
      const container = document.getElementById('scrollContainer');
      if (container && this.currentTimePosition > 0) {
        // Grid: 64px header (row 1), then 7.619px per 5-min slot (row 2 = 00:00)
        const pixelTop = 64 + (this.currentTimePosition - 2) * this.tripSheetRowPx;
        container.scrollTop = Math.max(0, pixelTop - 200);
      }
    }, 500);
  }

  draggingUnassignedTrip: any = null;

  scrollToTripTime(trip: any) {
    const container = document.getElementById('scrollContainer');
    if (!container || !trip || !trip.scheduleTime) return;
    const slotRow = this.getStartPoint(trip.scheduleTime, true);
    const pixelTop = 64 + (slotRow - 2) * this.tripSheetRowPx;
    container.scrollTo({ top: Math.max(0, pixelTop - 200), behavior: 'smooth' });
    this.draggingUnassignedTrip = trip;
  }

  onUnassignedDragEnded() {
    this.draggingUnassignedTrip = null;
  }

  getDragHighlightWrapperStyle() {
    return {
      'grid-template-rows': '64px repeat(288, 7.619px) auto',
      'grid-column': '1 / span ' + this.getDriverColumnCount()
    };
  }

  getDragHighlightBlockStyle() {
    if (!this.draggingUnassignedTrip) return {};
    const rowStart = this.getStartPoint(this.draggingUnassignedTrip.scheduleTime, true);
    const rowSpan = this.getEndPoint(this.draggingUnassignedTrip.scheduleTime, this.draggingUnassignedTrip.appointmentTime);
    return {
      'grid-row': rowStart + ' / span ' + rowSpan,
      'grid-column': '1 / -1'
    };
  }

  allTripsFilteration(){
    this.drivers = [];
    this.stationManagerList = [];
    let serviceAreas = [];
    let cooperates = [];
    let levelOfServices = [];
    let spaceTypes = [];
    this.allTrips.forEach(trip => {
      if (trip.driver) {
        if (this.isRdispatcher) {
          if (trip.driver.stationManager === this.user.sId) {
            this.drivers.push({ _id: trip.driver._id, displayName: trip.driver.displayName, stationManager: trip.driver.stationManager });
          }
        } else {
          this.drivers.push({ _id: trip.driver._id, displayName: trip.driver.displayName, stationManager: trip.driver.stationManager });
        }
      }



      if (trip.driver && trip.driver.stationManager) {

        if (this.isRdispatcher) {
          if (trip.driver.stationManager === this.user.sId) {
            this.stationManagerList.push(trip.driver.stationManager);
          }

        } else {
          this.stationManagerList.push(trip.driver.stationManager);
        }

      }

      if (trip.serviceArea) {
        serviceAreas.push(trip.serviceArea);
      }
      if (trip.cooperate) {
        cooperates.push(trip.cooperate);
      }
      if (trip.los) {
        levelOfServices.push(trip.los);
      }

      if (trip.spaceType) {
        spaceTypes.push(trip.spaceType);
      }
    });

    this.drivers = _.uniq(this.drivers, '_id').sort();
    this.stationManagerList = _.uniq(this.stationManagerList).sort();
    cooperates = _.uniq(cooperates).sort();
    levelOfServices = _.uniq(levelOfServices).sort();
    spaceTypes = _.uniq(spaceTypes).sort();

    if (serviceAreas && serviceAreas.length) {
      this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
    }
    if (cooperates && cooperates.length) {
      this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
    }

    if (levelOfServices && levelOfServices.length) {
      this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
    }

    if (spaceTypes && spaceTypes.length) {
      this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
    }
    this.filteredDrivers = this.drivers;

    this.filterTrips();
  }


  filterDriversbyStationManager() {
    this.filteredDrivers = []
    if (this.selectedStationManager && this.selectedStationManager.length) {
      this.filteredDrivers = this.drivers.filter(driver => {
        return this.selectedStationManager.includes(driver.stationManager);
      });
    } else {
      this.filteredDrivers = this.drivers;
    }
    this.filterTrips();
  }

filterTrips() {

  let filterdataList = JSON.parse(JSON.stringify(this.allTrips));

  filterdataList = filterdataList.filter(trip => {

    var isNoDriver = !trip.driver;

    var isDriverExist = true;
    var isStaffExist = true;
    var isServiceAreaExist = true;
    var isCorporateExist = true;
    var islosExist = true;
    var isSpaceTypeExist = true;
    var isCancelUnabled = true;
    var isSearchMatch = true;

    // ================= DRIVER FILTER =================
    if (this.selectedDriver && this.selectedDriver.length) {
      if (isNoDriver) {
        // allow no_driver unless search is applied
        isDriverExist = !this.search;
      } else {
        isDriverExist =
          trip.driver &&
          trip.driver._id &&
          this.selectedDriver.indexOf(trip.driver._id) !== -1;
      }
    }

    // ================= STATION MANAGER FILTER =================
    if (this.selectedStationManager && this.selectedStationManager.length) {
      if (isNoDriver) {
        isStaffExist = !this.search;
      } else {
        isStaffExist =
          trip.driver &&
          trip.driver.stationManager &&
          this.selectedStationManager.indexOf(trip.driver.stationManager) !== -1;
      }
    }

    // ================= OTHER FILTERS =================
    if (this.selectedServiceArea && this.selectedServiceArea.length) {
      isServiceAreaExist =
        trip.serviceArea &&
        this.selectedServiceArea.indexOf(trip.serviceArea) !== -1;
    }

    if (this.selectedCooperate && this.selectedCooperate.length) {
      isCorporateExist =
        trip.cooperate &&
        this.selectedCooperate.indexOf(trip.cooperate) !== -1;
    }

    if (this.selectedLOS && this.selectedLOS.length) {
      islosExist =
        trip.los &&
        this.selectedLOS.indexOf(trip.los) !== -1;
    }

    if (this.selectedSpaceType && this.selectedSpaceType.length) {
      isSpaceTypeExist =
        trip.spaceType &&
        this.selectedSpaceType.indexOf(trip.spaceType) !== -1;
    }

    // ================= CANCELLED FILTER =================
    if (this.isCancelUnabled) {
      isCancelUnabled = trip.status === 'cancelled';
    }

    // ================= SEARCH FILTER =================
    if (this.search && this.search.trim().length > 0) {

      var searchTerm = this.search.toLowerCase();

      var isDriverName = false;
      var isMemberName = false;
      var isTripId = false;
      var isMemberPhone = false;

      if (trip.driver && trip.driver.displayName) {
        isDriverName =
          trip.driver.displayName.toLowerCase().indexOf(searchTerm) !== -1;
      }

      if (trip.priorityClient && trip.priorityClient.displayName) {
        isMemberName =
          trip.priorityClient.displayName.toLowerCase().indexOf(searchTerm) !== -1;
      }

      if (trip.tripId) {
        isTripId =
          trip.tripId.toLowerCase().indexOf(searchTerm) !== -1;
      }

      if (trip.priorityClient && trip.priorityClient.cellPhone) {
        isMemberPhone =
          trip.priorityClient.cellPhone.toLowerCase().indexOf(searchTerm) !== -1;
      }

      isSearchMatch =
        isDriverName || isMemberName || isTripId || isMemberPhone;
    }

    // ================= FINAL RETURN =================
    return (
      isDriverExist &&
      isStaffExist &&
      isServiceAreaExist &&
      isCorporateExist &&
      islosExist &&
      isSpaceTypeExist &&
      isCancelUnabled &&
      (!this.search || isSearchMatch)
    );
  });

  // ================= GROUPING =================
  var groupedTrips = _.groupBy(filterdataList as any[], function(trip: any) {
    if (!trip.driver) return 'no_driver';

    if (typeof trip.driver === 'string') {
      return trip.driver;
    }

    return trip.driver._id ? trip.driver._id : 'no_driver';
  });

  // ================= DRIVER SORTING =================
  const tz = this.timeZone;
  if (this.sortBy === 'vehicle') {
    // Sort by vehicle registration number (fleet.setiDecall or rigNumber) alphabetically.
    // Drivers without a vehicle go last.
    this.driverList.sort((a: any, b: any) => {
      const getVehicleReg = (driver: any): string | null => {
        if (driver && driver.fleet && driver.fleet.setiDecall) return driver.fleet.setiDecall;
        if (driver && driver.rigNumber) return driver.rigNumber;
        return null;
      };
      const aReg = getVehicleReg(a);
      const bReg = getVehicleReg(b);
      if (!aReg && !bReg) return 0;
      if (!aReg) return 1;
      if (!bReg) return -1;
      return aReg.localeCompare(bReg, undefined, { numeric: true, sensitivity: 'base' });
    });
  } else {
    // Sort by earliest trip's scheduleTime. Drivers with no trips go last.
    this.driverList.sort((a: any, b: any) => {
      const aTrips: any[] = groupedTrips[a._id];
      const bTrips: any[] = groupedTrips[b._id];

      const getEarliest = (trips: any[]): number => {
        if (!trips || trips.length === 0) return Number.MAX_SAFE_INTEGER;
        return trips.reduce((min: number, trip: any) => {
          const t = trip.scheduleTime ? (moment as any)(trip.scheduleTime).tz(tz).valueOf() : Number.MAX_SAFE_INTEGER;
          return t < min ? t : min;
        }, Number.MAX_SAFE_INTEGER);
      };

      return getEarliest(aTrips) - getEarliest(bTrips);
    });
  }

  var dTrips = {};

  this.driverList.forEach(function(driver) {
    var trips = groupedTrips[driver._id];
    if (trips && trips.length) {
      dTrips[driver._id] = this.checkOverlaps(trips);
    }
  }.bind(this));

  this.driverTrips = dTrips;

  // ================= NO DRIVER HANDLING =================
  if (groupedTrips['no_driver']) {

    var unassignedTrips = groupedTrips['no_driver'].filter(function(trip) {
      return trip.jobStatus === 'pending' || trip.status === 'unassigned';
    });

    if (unassignedTrips.length) {
      this.driverTrips['no_driver'] = this.checkOverlaps(unassignedTrips);
    }
  }
}

  checkOverlaps(trips: any[]) {
    if (!trips || trips.length === 0) return [];

    const processed = [...trips].sort((a, b) => {
      const aStart = moment(a.scheduleTime).tz(this.timeZone).valueOf();
      const bStart = moment(b.scheduleTime).tz(this.timeZone).valueOf();
      if (aStart !== bStart) return aStart - bStart;
      const aEnd = moment(a.appointmentTime || moment(a.scheduleTime).tz(this.timeZone).add(30, 'minutes'))
        .tz(this.timeZone)
        .valueOf();
      const bEnd = moment(b.appointmentTime || moment(b.scheduleTime).tz(this.timeZone).add(30, 'minutes'))
        .tz(this.timeZone)
        .valueOf();
      return bEnd - aEnd;
    });

    processed.forEach(trip => {
      trip._tripSheetCushionMins = this.calculateTravelTime(trip, processed);
    });

    const overlapRange = (t: any) => {
      const cushionMins = this.getTripCushionMinutes(t);
      const sched = moment(t.scheduleTime).tz(this.timeZone);
      const start = sched.clone().subtract(cushionMins, 'minutes').valueOf();
      const end = t.appointmentTime
        ? moment(t.appointmentTime).tz(this.timeZone).valueOf()
        : sched.clone().add(30, 'minutes').valueOf();
      return { start, end };
    };

    const columns = []; // Array of end times for each column
    processed.forEach(trip => {
      const { start, end } = overlapRange(trip);

      let colIdx = -1;
      for (let i = 0; i < columns.length; i++) {
        if (start >= columns[i]) {
          colIdx = i;
          break;
        }
      }

      if (colIdx === -1) {
        columns.push(end);
        trip.subIndex = columns.length - 1;
      } else {
        columns[colIdx] = end;
        trip.subIndex = colIdx;
      }
    });

    // Same subTotal for every trip in a cushion/time overlap cluster (fixes earlier trip staying 100% width)
    const n = processed.length;
    const visited = new Array(n).fill(false);
    for (let s = 0; s < n; s++) {
      if (visited[s]) {
        continue;
      }
      const comp: number[] = [];
      const queue = [s];
      visited[s] = true;
      while (queue.length) {
        const j = queue.shift();
        comp.push(j);
        const tj = overlapRange(processed[j]);
        for (let k = 0; k < n; k++) {
          if (visited[k]) {
            continue;
          }
          const tk = overlapRange(processed[k]);
          if (tj.start < tk.end && tj.end > tk.start) {
            visited[k] = true;
            queue.push(k);
          }
        }
      }
      let maxSub = 0;
      comp.forEach((idx) => {
        maxSub = Math.max(maxSub, processed[idx].subIndex || 0);
      });
      const subTotal = maxSub + 1;
      comp.forEach((idx) => {
        processed[idx].subTotal = subTotal;
      });
    }

    this.computeDelayChain(processed);

    return processed;
  }

  private computeDelayChain(trips: any[]): void {
    const realNow = moment().tz(this.timeZone);
    const selectedDay = moment(this.todayDate).tz(this.timeZone);
    // Overdue check only applies when the selected date is today.
    const now = selectedDay.isSame(realNow, 'day') ? realNow : null;

    const tripChain = trips.filter(t => !t.isBreakTrip);
    let prevEffectiveEnd: any = null;

    tripChain.forEach((trip, idx) => {
      const sched = moment(trip.scheduleTime).tz(this.timeZone);
      const appt = trip.appointmentTime
        ? moment(trip.appointmentTime).tz(this.timeZone)
        : sched.clone().add(30, 'minutes');
      const durationMins = Math.max(appt.diff(sched, 'minutes'), 5);
      const cushionMins: number =
        trip._tripSheetCushionMins != null && !isNaN(Number(trip._tripSheetCushionMins))
          ? Number(trip._tripSheetCushionMins)
          : 15;

      let effectiveStart: any;
      let isDelayed = false;
      let delayMins = 0;

      if (idx === 0 || !prevEffectiveEnd) {
        effectiveStart = sched.clone();
        if (now && (trip.status === 'offered' || trip.status === 'accepted') && sched.isBefore(now)) {
          isDelayed = true;
          delayMins = Math.round(now.diff(sched, 'minutes'));
        }
      } else {
        const earliestArrival = prevEffectiveEnd.clone().add(cushionMins, 'minutes');
        if (earliestArrival.isAfter(sched)) {
          effectiveStart = earliestArrival;
          isDelayed = true;
          delayMins = Math.round(earliestArrival.diff(sched, 'minutes'));
        } else {
          effectiveStart = sched.clone();
          if (now && (trip.status === 'offered' || trip.status === 'accepted') && sched.isBefore(now)) {
            isDelayed = true;
            delayMins = Math.round(now.diff(sched, 'minutes'));
          }
        }
      }

      trip._isDelayed = isDelayed;
      trip._delayMins = delayMins;
      // Forecast ETA = estimated time driver will arrive at the pickup location
      trip._forecastETA = effectiveStart.format('HH:mm');
      prevEffectiveEnd = effectiveStart.clone().add(durationMins, 'minutes');
    });
  }

  /**
   * 5-minute grid rows for the cushion strip (travel from previous trip, or default).
   */
  getTravelRows(trip: any, uiTrips: any[]): number {
    return Math.ceil(this.calculateTravelTime(trip, uiTrips) / 5);
  }

  private calculateTravelTime(currentTrip: any, uiTrips: any[]): number {
    if (!uiTrips || !uiTrips.length || !this.timeZone) {
      return 15;
    }
    const sorted = [...uiTrips].sort(
      (a, b) =>
        moment(a.scheduleTime).tz(this.timeZone).valueOf() -
        moment(b.scheduleTime).tz(this.timeZone).valueOf()
    );
    const idx = sorted.findIndex(
      t =>
        (currentTrip.tripId && t.tripId === currentTrip.tripId) ||
        (currentTrip._id && t._id === currentTrip._id)
    );

    if (idx <= 0) {
      return 15;
    }

    const prev = sorted[idx - 1];
    const lat1 = prev.jobDestinationLatitude;
    const lon1 = prev.jobDestinationLongitude;
    const lat2 = currentTrip.jobOriginLatitude;
    const lon2 = currentTrip.jobOriginLongitude;

    if (!lat1 || !lon1 || !lat2 || !lon2) {
      return 15;
    }

    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    const mins = Math.round((distance / 40) * 60);

    return Math.min(Math.max(mins, 5), 120);
  }

  getTripCushionMinutes(trip: any): number {
    if (trip && trip._tripSheetCushionMins != null && !isNaN(Number(trip._tripSheetCushionMins))) {
      return Number(trip._tripSheetCushionMins);
    }
    return 15;
  }

  getTripCushionRows(trip: any): number {
    return Math.ceil(this.getTripCushionMinutes(trip) / 5);
  }

  getTripCushionStripStyle(trip: any): { [key: string]: string } {
    if (trip.isBreakTrip) {
      return {};
    }
    const rows = this.getTripCushionRows(trip);
    const px = this.tripSheetRowPx;
    return {
      top: `calc(-${rows} * ${px}px)`,
      height: `calc(${rows} * ${px}px + 0.25rem)`,
    };
  }

  /** Dashed outline top offset must match cushion strip. */
  getTripCushionOutlineStyle(trip: any): { [key: string]: string } {
    if (trip.isBreakTrip) {
      return {};
    }
    const rows = this.getTripCushionRows(trip);
    return { top: `calc(-${rows} * ${this.tripSheetRowPx}px)` };
  }

  getNumberOfDrivers() {
    return Object.keys(this.driverTrips).length;
  }

  getStartPoint(date, b = true) {
    const time = moment(date).tz(this.timeZone);
    const totalMinutes = time.hours() * 60 + time.minutes();
    const slotIndex = Math.floor(totalMinutes / 5);

    // Row 1 is the 1.75rem header. 00:00 starts at Row 2.
    // If b is false (used for durations/offsets), we return the raw slot index + 1?
    // Actually, for duration span, we should use a separate method.
    return slotIndex + (b ? 2 : 1);
  }

  getEndPoint(dateOne, dateTwo) {
    const time1 = moment(dateOne).tz(this.timeZone);
    const time2 = moment(dateTwo).tz(this.timeZone);
    let diffInMinutes = time2.diff(time1, 'minutes');
    if (diffInMinutes < 5) diffInMinutes = 5;
    return Math.ceil(diffInMinutes / 5);
  }


  getShiftStartPoint(date, b = true) {
    const modifiedDate = moment(date, 'HH:mm').toISOString();
    return this.getStartPoint(modifiedDate, b);
  }


  getShiftEndPoint(dateOne, dateTwo) {
    const modifiedDate1 = moment(dateOne, 'HH:mm').toISOString();
    const modifiedDate2 = moment(dateTwo, 'HH:mm').toISOString();
    return this.getEndPoint(modifiedDate1, modifiedDate2);
  }

  calculateMinutesValue(value) {
    return Math.round(((value * 12) / 60));
  }

  openDetailModal(trip){
    this.tripDetailModalObj = trip
  }

  onTripDropped(event: CdkDragDrop<any>) {
    const trip = event.item.data;
    const driverId = event.container.data;
    const previousDriverId = event.previousContainer.data;

    if (driverId && driverId.startsWith('empty_')) {
      return;
    }

    // Same column: attempt Y-axis time reschedule (only for unassigned/offered)
    if (driverId === previousDriverId) {
      if (
        driverId !== 'no_driver' &&
        (trip.status === 'unassigned' || trip.status === 'offered') &&
        Math.abs(event.distance.y) >= this.tripSheetRowPx
      ) {
        this.initiateTimeReschedule(trip, event.distance.y);
      }
      return;
    }

    const targetDriver = (this.preDriverList as any)[driverId];
    const alertMessage = this.getAlertMessage(driverId, targetDriver);

    // Capture pre-state for undo
    const prevDriverId = trip.driver
      ? (typeof trip.driver === 'object' ? trip.driver._id : trip.driver)
      : null;
    const prevStatus: string = trip.status;
    const prevJobStatus: string = trip.jobStatus;
    const prevDriverObj = trip.driver ? (typeof trip.driver === 'object' ? { ...trip.driver } : (this.preDriverList as any)[trip.driver]) : null;
    const prevDriverName = prevDriverObj ? prevDriverObj.displayName : 'Unassigned';

    sweetAlert('Alert', alertMessage, 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          if (driverId === 'no_driver') {
            // Push undo entry before mutating
            this.undoStack.push({ type: 'assign', trip, prevDriverId, prevStatus, prevJobStatus, driverName: prevDriverName });
            this.cdr.detectChanges();

            this.selectedTrip = trip;
            this.unAssignTrip();
            return;
          }

          // Assign to a driver
          if (driverId && driverId !== 'no_driver') {
            const payload = { ...trip };

            // Push undo entry before mutating
            this.undoStack.push({ type: 'assign', trip, prevDriverId, prevStatus, prevJobStatus, driverName: prevDriverName });
            this.cdr.detectChanges();

            // Optimistic Update: Move locally first — use full driver object so
            // allTripsFilteration can correctly populate filteredDrivers.
            const fullDriver = (this.preDriverList as any)[driverId];
            payload.driver = fullDriver ? { ...fullDriver } : { _id: driverId };
            payload.status = 'offered';
            payload.jobStatus = 'offered';

            // Update in allTrips so filtration picks it up
            const tripIndex = this.allTrips.findIndex(t => t._id === trip._id);
            if (tripIndex !== -1) {
              this.allTrips[tripIndex] = payload;
              this.allTripsFilteration();
            }

            this.assignSingleTrip(payload);
          }
        }
      });
  }
  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }



  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  showDriverBreak(val){
    this.showBreak = val
    this.allTrips = [];
    this.driverTrips = [];
    this.getTrips();
  }

  currentDayShift(shifts) {
    const currentDay = moment(this.todayDate).tz(this.timeZone).day();
    if (shifts) {
      let shift = shifts.find(shift => shift.day === currentDay);
      return shift;
    } else {
      return {};
    }
  }

  onResetTime() {
    this.skip = 0;
    this.allTrips = [];
    this.driverTrips = [];
    this.timeRange = [
      moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(),
      moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString(),
    ]
    this.getTrips();
  }
  onTimeChange(event) {
    this.skip = 0;
    this.allTrips = [];
    this.driverTrips = [];
    this.driversTimelines = {};
    // debugger;
    this.timeRange = [event[0].toISOString(), event[1].toISOString()];
    this.getTrips();
  }

  onDateChange(event) {
    this.skip = 0;
    this.allTrips = [];
    this.driverTrips = [];
    this.todayDate = event.toISOString();
    this.timeRange = [event.toISOString(), event.endOf("day").toISOString()];
    this.updateCurrentTimePosition();
    this.driversTimelines = {};
    // this.todayDate =
    //   [
    //     event[0].toISOString(),
    //     event[1].endOf("day").toISOString(),
    //   ]
    this.isAllowToHover = false;
    this.getTrips();
    this.getDriversTimelines();
  }

  getTimeRestrictions() {
      return { min: moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(), max: moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString() }
  }

  getAssisData(){
    this.assistService.getAllAssists()
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        // this.assists = data;
        this.preAssistList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

      }
    });
  }

  getFleetList() {
    this.fleetService
      .getFleetList({'isFleetSection': true,'status': this.status})
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleetList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  toggleStatusDropdown() {
    this.isShowStatusDropdown = !this.isShowStatusDropdown
  }

  onChangeStatus() {
    this.isAllowToHover = false;
    this.skip = 0;
    this.allTrips = [];
    this.driverTrips = [];
    this.getTrips();
  }

  sortMethod() {
    return 0;
  }
  createTrip(event: MouseEvent) {
    const startingPoint = document.getElementById('startingPoint');
    if (!startingPoint) return;

    const rect = startingPoint.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const clickY = event.clientY - rect.top;

    const displayDrivers = this.getDisplayDrivers();
    const totalDrivers = displayDrivers.length;
    const totalTimeSlots = 288; // 24 hours * 12 slots/hour

    const gridWidth = startingPoint.offsetWidth;
    const gridHeight = startingPoint.offsetHeight;

    const driverWidth = gridWidth / totalDrivers;
    const timeSlotHeight = gridHeight / totalTimeSlots;

    const clickedDriverIndex = Math.floor(clickX / driverWidth);
    const clickedTimeSlotIndex = Math.floor(clickY / timeSlotHeight);

    if (clickedDriverIndex < 0 || clickedDriverIndex >= totalDrivers) return;
    if (clickedTimeSlotIndex < 0 || clickedTimeSlotIndex >= totalTimeSlots) return;

    const driverId = displayDrivers[clickedDriverIndex];
    if (driverId.startsWith('empty_')) return;

    const totalMinutes = clickedTimeSlotIndex * 5;
    const scheduleTime = moment(this.todayDate).tz(this.timeZone).startOf('day').add(totalMinutes, 'minutes');

    this.scheduleTime = scheduleTime;
    this.driverId = driverId === 'no_driver' ? undefined : driverId;
  }


  onEditTrip(trip) {
    if (trip) {
      trip.driver = this.driverList.find(driver=> driver._id === trip.driver);
      this.allTrips.push(trip);
      this.allTripsFilteration();
      this.scheduleTime = null;
      this.driverId = null;
    }
  }

  getDriversTimelines() {
    const queryString = {};
    const range = [moment(this.todayDate).startOf("day").toISOString(), moment(this.todayDate).endOf("day").toISOString()];
    queryString['dates'] = { "startDate": range[0], "endDate": range[1] };
    this.driverService
      .getAllDriverTimelines(queryString)
      .subscribe(data => {
        if (data && data.length) {
          this.driversTimelines = data.reduce((acc, item) => {
            const {_id, jobs} = item;
            const driverId = _id.driver;
            acc[driverId] = {
              checkin: jobs && jobs.length ? jobs[0].checkin : null,
              checkout: jobs && jobs.length ? jobs[0].checkout : null
            }
            return acc;
          }, {});
          console.log(this.driversTimelines);
        }
      });
  }

  shiftBreakdown(driverId) {
    const shift = this.driversTimelines[driverId];
    const driverTrips = this.driverTrips[driverId] || [];
    const breakdown = {};

    // 1. Check if we have Actual/Logged Shift data
    if (shift && shift.checkin) {
      let { checkin, checkout } = shift;
      const checkinMoment = moment(checkin).tz(this.timeZone);
      const checkinHours = checkinMoment.format("HH:mm");

      if (!checkout) {
        // Active Shift (Not Ended)
        const supposedCheckout = checkinMoment.clone().add(8, 'hours');
        const supposedCheckoutHours = supposedCheckout.format("HH:mm");

        breakdown['shift_started.regular_window'] = {
          start: this.getShiftStartPoint(checkinHours, true),
          end: this.getShiftEndPoint(checkinHours, supposedCheckoutHours)
        };

        // Check for Overtime if trips exist beyond supposed checkout
        if (driverTrips.length) {
          const lastTrip = driverTrips[driverTrips.length - 1];
          const apt = moment(lastTrip.appointmentTime || moment(lastTrip.scheduleTime).add(30, 'm')).tz(this.timeZone);
          if (apt.isAfter(supposedCheckout)) {
            breakdown['shift_started.overtime_window'] = {
              start: this.getShiftStartPoint(supposedCheckoutHours, true),
              end: this.getShiftEndPoint(supposedCheckoutHours, apt.format("HH:mm"))
            };
          }
        }
      } else {
        // Completed Shift
        const checkoutMoment = moment(checkout).tz(this.timeZone);
        const checkoutHours = checkoutMoment.format("HH:mm");
        const totalHoursWorked = checkoutMoment.diff(checkinMoment, 'hours', true);

        if (totalHoursWorked > 8) {
          const regularShiftEndHours = checkinMoment.clone().add(8, 'hours').format('HH:mm');
          breakdown['shift_ended.regular_window'] = {
            start: this.getShiftStartPoint(checkinHours, true),
            end: this.getShiftEndPoint(checkinHours, regularShiftEndHours)
          };
          breakdown['shift_ended.overtime_window'] = {
            start: this.getShiftStartPoint(regularShiftEndHours, true),
            end: this.getShiftEndPoint(regularShiftEndHours, checkoutHours)
          };
        } else {
          breakdown['shift_ended.regular_window'] = {
            start: this.getShiftStartPoint(checkinHours, true),
            end: this.getShiftEndPoint(checkinHours, checkoutHours)
          };
        }
      }
      return breakdown;
    }

    // 2. Fallback to Scheduled Shift if not checked in
    const driver = this.driverList.find(d => d._id === driverId);
    if (driver && driver.shifts) {
      const now = moment(this.todayDate).tz(this.timeZone);
      const scheduledShift = driver.shifts.find(s => s.isEnabled && s.day === now.day());

      if (scheduledShift && scheduledShift.checkin && scheduledShift.checkout) {
        breakdown['shift_started.regular_window'] = {
          start: this.getShiftStartPoint(scheduledShift.checkin, true),
          end: this.getShiftEndPoint(scheduledShift.checkin, scheduledShift.checkout)
        };
        return breakdown;
      }
    }

    return null;
  }

  trackById(index: number, item: any): number {
    return item.key;
  }

  isDisabledDrag(trip) {
    return !['offered', 'accepted', 'unassigned'].includes(trip.status)
  }

  getConnectedZoneIds(currentZoneId: string): string[] {
    const filtered = Object.keys(this.driverTrips).filter(key => key !== currentZoneId)
    return filtered;

  }

  onDrop(event: CdkDragDrop<string[]>, zoneId: string) {
    const targetDriver = this.preDriverList[zoneId];
    const alertMessage = this.getAlertMessage(zoneId, targetDriver);

    const from = event.previousContainer.data;
    const to = event.container.data;
    const trip = from[event.previousIndex];

    if (to === from) return;

    sweetAlert('Alert', alertMessage, 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {

          if (event.previousContainer === event.container) {
            moveItemInArray(to, event.previousIndex, event.currentIndex);
          } else {
            transferArrayItem(from, to, event.previousIndex, event.currentIndex);
          }

          // Check if unassigning
          if (zoneId === 'no_driver') {
            this.selectedTrip = trip;
            this.unAssignTrip();
          } else {
            this.selectedTrip = trip;
            this.selectedDriver = targetDriver;
            this.assignTrip();
          }
        }
      });
  }

  getAlertMessage(zoneId: string, targetDriver: any): string {
    return zoneId === 'no_driver'
      ? 'Are you sure you want to unassign this trip?'
      : `Are you sure you want to assign this trip to ${ targetDriver.displayName }?`;
  }

  assignTrip() {
    this.selectedTrip.driver = this.selectedDriver._id;
    this.selectedTrip.status = 'offered';
    this.selectedTrip.jobStatus = 'offered';
    this.assignSingleTrip(this.selectedTrip);
  }

  unAssignTrip() {
      this.selectedTrip.jobStatus = 'pending';
      this.selectedTrip.status = 'unassigned';
      this.selectedTrip.driver = null; // Clear driver
      this.allTripsFilteration(); // Update UI instantly
      this.updateSingleTrip(this.selectedTrip);
  }

  assignSingleTrip(payload) {

    this.assignTripService
      .assignTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.selectedTrip = null;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  updateSingleTrip(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
           this.selectedTrip = null;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  undoLastAssignment() {
    if (!this.undoStack.length) return;
    const entry = this.undoStack.pop()!;

    const trips: any[] = this.allTrips as any[];
    const tripIndex = trips.findIndex((t: any) => t._id === entry.trip._id);
    const liveTripObj: any = tripIndex !== -1 ? trips[tripIndex] : entry.trip;

    if (entry.type === 'reschedule') {
      liveTripObj.scheduleTime = entry.prevScheduleTime;
      liveTripObj.appointmentTime = entry.prevAppointmentTime;

      if (tripIndex !== -1) {
        trips[tripIndex] = { ...liveTripObj };
      }

      this.allTripsFilteration();
      this.cdr.detectChanges();
      this.updateSingleTrip({ ...liveTripObj });
      return;
    }

    // type === 'assign'
    const prevDriverObj = entry.prevDriverId
      ? (this.preDriverList as any)[entry.prevDriverId]
      : null;

    liveTripObj.driver = prevDriverObj ? { ...prevDriverObj } : null;
    liveTripObj.status = entry.prevStatus;
    liveTripObj.jobStatus = entry.prevJobStatus;

    if (tripIndex !== -1) {
      trips[tripIndex] = { ...liveTripObj };
    }

    this.allTripsFilteration();
    this.cdr.detectChanges();

    const payload = { ...liveTripObj };
    if (entry.prevDriverId) {
      this.assignSingleTrip(payload);
    } else {
      payload.driver = null;
      this.updateSingleTrip(payload);
    }
  }

  onClickTripCard(trip) {
    if (trip.isBreakTrip) {
      return;
    }
    if (trip.job) {
      this.viewCompletedTripDetails(trip);
    } else {
      this.openDetailModal(trip);
    }
  }

  ngOnDestroy(): void {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    this.undoStack = [];
  }

  getDisplayDrivers() {
    // Use driverList order (sorted stably by checkIn) to prevent columns from
    // reordering when trips are dragged. filteredDrivers acts as a filter mask.
    const filteredSet = new Set((this.filteredDrivers || []).map(d => d._id));

    const result = (this.driverList as any[])
      .filter(d => filteredSet.has(d._id))
      .map(d => d._id as string);

    // Pad with empty slots to ensure there are at least 'driversPerPage' columns.
    while (result.length < this.driversPerPage) {
      result.push(`empty_${result.length}`);
    }

    return result;
  }

  onLimitChange() {
    let n = Number(this.driversPerPage);
    if (isNaN(n)) {
      n = this.driversPerPageMin;
    }
    n = Math.max(
      this.driversPerPageMin,
      Math.min(this.driversPerPageMax, n)
    );
    n = Math.round(n / this.driversPerPageStep) * this.driversPerPageStep;
    n = Math.max(
      this.driversPerPageMin,
      Math.min(this.driversPerPageMax, n)
    );
    this.driversPerPage = n;
  }

  incrementDriversPerPage() {
    const next = this.driversPerPage + this.driversPerPageStep;
    if (next <= this.driversPerPageMax) {
      this.driversPerPage = next;
      this.onLimitChange();
    }
  }

  decrementDriversPerPage() {
    const next = this.driversPerPage - this.driversPerPageStep;
    if (next >= this.driversPerPageMin) {
      this.driversPerPage = next;
      this.onLimitChange();
    }
  }

  getDriverName(driverId: string) {
    if (driverId === 'no_driver') return 'Unassigned';
    if (driverId.startsWith('empty_')) return '';
    const driver = this.preDriverList[driverId];
    return (driver && driver.displayName) || 'Unknown';
  }

  getDriverImage(driverId: string) {
    if (driverId === 'no_driver' || driverId.startsWith('empty_')) {
      return 'assets/images/placeholders/driver-placeholder.png';
    }
    const driver = this.preDriverList[driverId];
    return (driver && driver.profileImageURL) || 'assets/images/placeholders/driver-placeholder.png';
  }

  getDriverRigNumber(driverId: string) {
    if (driverId === 'no_driver' || driverId.startsWith('empty_')) return 'N/A';
    const driver = this.preDriverList[driverId];
    if (driver && driver.fleet && driver.fleet.setiDecall) {
      return driver.fleet.setiDecall;
    }
    if (driver && driver.rigNumber) {
      return driver.rigNumber;
    }
    return 'N/A';
  }

  /** Haversine distance in minutes at 40 km/h between two lat/lon points. */
  private haversineMinutes(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const dist = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return Math.min(Math.max(Math.round((dist / 40) * 60), 1), 120);
  }

  /** Native tooltip (title) for trip row hover — enriched with forecast ETA. */
  getTripCardTitle(trip: any): string | null {
    if (!trip || !trip.scheduleTime) return null;
    return this.buildTripTooltip(trip);
  }

  private buildTripTooltip(trip: any): string {
    const tz = this.timeZone;
    // Use moment.tz(value, tz) — static method, no "namespace not callable" issue.
    const start = moment.tz(trip.scheduleTime, tz).format('HH:mm');
    const end   = moment.tz(trip.appointmentTime || trip.scheduleTime, tz).format('HH:mm');

    if (trip.isBreakTrip) return `${start} – ${end} (driver break)`;

    const lines: string[] = [];
    lines.push(`Scheduled: ${start} → ${end}`);

    if (trip._tripSheetCushionMins != null) {
      lines.push(`Travel from prev: ${trip._tripSheetCushionMins} min`);
    }

    const jobStatus = trip.jobStatus;
    const trackInfo = trip.job && trip.job.trackInfoJob;

    if (trip.status === 'finished') {
      if (trackInfo && trackInfo.jobArrived && trackInfo.jobArrived.time) {
        lines.push(`Arrived at pickup: ${moment.tz(trackInfo.jobArrived.time, tz).format('HH:mm')}`);
      }
      if (trackInfo && trackInfo.jobFinished && trackInfo.jobFinished.time) {
        lines.push(`Completed: ${moment.tz(trackInfo.jobFinished.time, tz).format('HH:mm')}`);
      }

    } else if (jobStatus === 'arrived' || jobStatus === 'started') {
      if (trackInfo && trackInfo.jobArrived && trackInfo.jobArrived.time) {
        const arrivedAt   = moment.tz(trackInfo.jobArrived.time, tz);
        const scheduledAt = moment.tz(trip.scheduleTime, tz);
        const diff = arrivedAt.diff(scheduledAt, 'minutes');
        const diffStr = diff <= 0 ? `${Math.abs(diff)} min early` : `${diff} min late`;
        lines.push(`Arrived: ${arrivedAt.format('HH:mm')} (${diffStr})`);
      } else if (trip._forecastETA) {
        lines.push(`Est. ETA (pickup): ${trip._forecastETA}`);
      }

    } else if (jobStatus === 'onway') {
      let etaShown = false;
      if (
        trackInfo && trackInfo.jobAccepted &&
        trackInfo.jobAccepted.coords && trackInfo.jobAccepted.coords.length >= 2 &&
        trip.jobOriginLatitude && trip.jobOriginLongitude
      ) {
        // coords are [lon, lat] (GeoJSON order)
        const travelMins = this.haversineMinutes(
          trackInfo.jobAccepted.coords[1], trackInfo.jobAccepted.coords[0],
          trip.jobOriginLatitude, trip.jobOriginLongitude
        );
        const etaTime = moment.tz(tz).add(travelMins, 'minutes').format('HH:mm');
        lines.push(`Live ETA (pickup): ${etaTime} (~${travelMins} min away)`);
        etaShown = true;
      }
      if (!etaShown && trip._forecastETA) {
        lines.push(`Forecast ETA: ${trip._forecastETA}`);
      }

    } else {
      if (trip._forecastETA) {
        lines.push(`Forecast ETA: ${trip._forecastETA}`);
      }
      if (trip._isDelayed && trip._delayMins > 0) {
        lines.push(`⚠ LATE by ${trip._delayMins} min`);
      }
    }

    return lines.join('\n');
  }

  getDriverColumnCount() {
    const total = (this.filteredDrivers || []).length;
    return Math.max(total, this.driversPerPage);
  }

  trackByDriverId(index: number, driverId: string) {
    return driverId;
  }

  trackByTripId(_index: number, trip: any) {
    return trip._id;
  }

  getTripLeg(tripId: string): string | null {
    if (!tripId) return null;
    const match = tripId.match(/\(([^)]+)\)/);
    return match ? match[1] : null;
  }

  /**
   * One column per driver; overlapping trips split width by subTotal (e.g. 2 → 50% / 50%).
   * Avoids repeat(globalMaxSubTotal) which left empty tracks when another part of the day had more overlaps.
   */
  getTripGridItemStyle(trip: any): { [key: string]: string } {
    const subTotal = trip.subTotal || 1;
    const subIndex = trip.subIndex || 0;
    const gridRow =
      this.getStartPoint(trip.scheduleTime, true) +
      ' / span ' +
      this.getEndPoint(trip.scheduleTime, trip.appointmentTime);
    const style: { [key: string]: string } = {
      'grid-row': gridRow,
      'grid-column': '1 / -1',
      'justify-self': 'start',
      'z-index': String(subIndex + 1),
      'box-sizing': 'border-box',
    };
    if (subTotal <= 1) {
      style['width'] = '100%';
      style['margin-left'] = '0%';
    } else {
      style['width'] = 100 / subTotal + '%';
      style['margin-left'] = (100 / subTotal) * subIndex + '%';
    }
    return style;
  }

  initiateTimeReschedule(trip: any, deltaY: number) {
    const minutesDelta = Math.round(deltaY / this.tripSheetRowPx) * 5;
    if (minutesDelta === 0) return;

    const oldMoment = (moment as any)(trip.scheduleTime).tz(this.timeZone);
    const newMoment = oldMoment.clone().add(minutesDelta, 'minutes');
    const newScheduleTime = newMoment.toISOString();
    const newAppointmentTime = trip.appointmentTime
      ? (moment as any)(trip.appointmentTime).tz(this.timeZone).add(minutesDelta, 'minutes').toISOString()
      : null;

    this.timeRescheduleModalObj = {
      trip,
      oldScheduleTime: trip.scheduleTime,
      oldAppointmentTime: trip.appointmentTime || null,
      newScheduleTime,
      newAppointmentTime,
      oldTimeDisplay: oldMoment.format('HHmm'),
      newTimeDisplay: newMoment.format('HHmm')
    };
  }

  confirmTimeReschedule() {
    if (!this.timeRescheduleModalObj) return;
    const { trip, newScheduleTime, newAppointmentTime, oldScheduleTime, oldAppointmentTime } = this.timeRescheduleModalObj;

    // Push undo entry before mutating
    const prevDriverId = trip.driver
      ? (typeof trip.driver === 'object' ? trip.driver._id : trip.driver)
      : null;
    const prevDriverObj = trip.driver
      ? (typeof trip.driver === 'object' ? trip.driver : (this.preDriverList as any)[trip.driver])
      : null;
    this.undoStack.push({
      type: 'reschedule',
      trip,
      prevDriverId,
      prevStatus: trip.status,
      prevJobStatus: trip.jobStatus,
      driverName: prevDriverObj ? prevDriverObj.displayName : 'Unassigned',
      prevScheduleTime: oldScheduleTime,
      prevAppointmentTime: oldAppointmentTime
    });
    this.cdr.detectChanges();

    const trips = this.allTrips as any[];
    const tripIndex = trips.findIndex((t: any) => t._id === trip._id);
    if (tripIndex !== -1) {
      trips[tripIndex] = {
        ...trips[tripIndex],
        scheduleTime: newScheduleTime,
        appointmentTime: newAppointmentTime
      };
      this.allTripsFilteration();
    }

    const payload = { ...trip, scheduleTime: newScheduleTime, appointmentTime: newAppointmentTime };
    this.updateSingleTrip(payload);
    this.timeRescheduleModalObj = null;
  }

  cancelTimeReschedule() {
    this.timeRescheduleModalObj = null;
  }

  formatTzTime(isoString: string): string {
    if (!isoString) return '';
    return (moment as any)(isoString).tz(this.timeZone).format('h:mm A');
  }

  openAssignModal(trip) {
    this.assignModalObj = trip;
    this.componentType = 'unassign';
  }

  onAssignTrip(evt) {
    if (evt) {
      this.assignModalObj = null;
      this.refreshTrips();
    }
  }

  onCloseAssignModal() {
    this.assignModalObj = null;
  }

  openDriverTripDetailModal(id) {
    this.driverTripModalObj = id;
  }

  closeModal(evt) {
    this.driverTripModalObj = null;
  }

  toggleTimer() {
    this.isTimerEnabled = !this.isTimerEnabled;
    if (this.isTimerEnabled) {
      this.skip = 0;
      this.allTrips = [];
      this.driverTrips = [];
      this.timeRange = [
        moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(),
        moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString(),
      ]
      this.getTrips();
    } else {
      this.timer.init();
    }
  }

  onTimerComplete(): void {
     this.timer.init();
    this.skip = 0;
    this.allTrips = [];
    this.driverTrips = [];
    this.timeRange = [
      moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(),
      moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString(),
    ]
    this.getTrips();
  }

}



